import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { BoardTaskCommentRequest } from '../../../common/types/task';

interface DraftCommentsState {
  comments: Record<
    number,
    {
      body: string;
      request: BoardTaskCommentRequest;
    }
  >;
}

const draftCommentsInitialState: DraftCommentsState = {
  comments: {},
};

const ensureDraftExists = (state: DraftCommentsState, taskId: number) => {
  if (!state.comments[taskId]) {
    state.comments[taskId] = {
      body: '',
      request: 'NONE',
    };
  }
};

export const draftCommentsSlice = createSlice({
  name: 'boardDraftComments',
  initialState: draftCommentsInitialState,
  reducers: {
    setCommentBody(state, action: PayloadAction<{ taskId: number; body: string }>) {
      const { taskId, body } = action.payload;

      ensureDraftExists(state, taskId);
      state.comments[taskId].body = body;
    },

    setCommentRequest(state, action: PayloadAction<{ taskId: number; request: BoardTaskCommentRequest }>) {
      const { taskId, request } = action.payload;

      ensureDraftExists(state, taskId);
      state.comments[taskId].request = request;
    },

    clearCommentDraft(state, action: PayloadAction<number>) {
      delete state.comments[action.payload];
    },
  },
});

export const draftCommentsReducer = draftCommentsSlice.reducer;

export const { setCommentBody, setCommentRequest, clearCommentDraft } = draftCommentsSlice.actions;
